import { render, staticRenderFns } from "./DefaultPersonalizedRecommendation.vue?vue&type=template&id=2aa34be3&scoped=true&"
import script from "./DefaultPersonalizedRecommendation.vue?vue&type=script&lang=js&"
export * from "./DefaultPersonalizedRecommendation.vue?vue&type=script&lang=js&"
import style0 from "./DefaultPersonalizedRecommendation.vue?vue&type=style&index=0&id=2aa34be3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa34be3",
  null
  
)

export default component.exports